import { css } from 'emotion';

export namespace styles {
  export const containerRules = css({
    padding: '0 15px',
    marginTop: 15
  });
}
